<template>
<div>
    <div id="page-panel">
        <div class="customer-top-nav">
            <div class="title">
            <span>{{$t('reports.names.WINE_SALES_PRODUCT_PERFORMANCE')}}</span><br>
            </div>
          <div class="controls no-print">
            <el-dropdown size="small" type="default" class="">
              <el-button type="primary" size="small" :disabled="!itemSelected">
                <i class="el-icon-download"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="downloadExcel"><i class="mdi mdi-file-excel"/> Excel</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div>
            {{ myInventory.name }}
            <el-autocomplete class="inline-input" :trigger-on-focus="false" value-key="name" v-model="model.item" style="width:100%;" :fetch-suggestions="querySearch" :placeholder="$t('sales_orders.selectProduct')" @select="handleSelect">
                <template slot-scope="{ item }">
                    <ItemTemplate :product="item" :showQty="false" :showInventoryName="false" :inventory="item.inventory" :format="item.format" :volume="item.volume"></ItemTemplate>
                </template>
            </el-autocomplete>
            <div style="margin-top:8px;">
                <span style="font-size:12px;margin-right:8px;color:#606266;">Période de mise en disponibilité :</span>
                <el-select v-model="periodMonths" size="small" style="width:180px;" @change="fetchItemsPerformanceIfSelected">
                    <el-option :value="6" label="6 derniers mois"></el-option>
                    <el-option :value="12" label="12 derniers mois"></el-option>
                    <el-option :value="18" label="18 derniers mois"></el-option>
                    <el-option :value="24" label="24 derniers mois"></el-option>
                    <el-option :value="36" label="36 derniers mois"></el-option>
                </el-select>
            </div>
            <el-divider></el-divider>
            <div v-if="!itemSelected" class="empty-selection-message">
              Veuillez sélectionner un produit pour afficher la performance, l'historique des ventes et la distribution.
            </div>
            <div v-else>
            <el-row :gutter="5">
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <ItemTemplate v-if="itemSelected" :product="itemSelected" :showQty="false" :showInventoryName="false" :inventory="itemSelected.inventory" :format="itemSelected.format" :volume="itemSelected.volume"></ItemTemplate>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <el-row :gutter="8">
                  <el-col :span="14">
                    <div class="concentration-card">
                      <div class="concentration-title">Score de vente rapide</div>
                      <div class="concentration-score" :class="perf120Class">
                        {{ perf120Score }}<span class="concentration-unit">/100</span>
                      </div>
                      <div class="concentration-label" :class="perf120Class">{{ perf120Label }}</div>
                      <div class="concentration-hint">Pourcentage des unités vendues dans les 120 premiers jours suivant la mise en disponibilité du lot.</div>
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <div class="concentration-card">
                      <div class="concentration-title">Indice de concentration des ventes</div>
                      <div class="concentration-score" :class="concentrationRiskClass">
                        {{ concentrationRiskScore }}<span class="concentration-unit">/100</span>
                      </div>
                      <div class="concentration-label" :class="concentrationRiskClass">{{ concentrationRiskLabel }}</div>
                      <div class="concentration-hint">Basé sur l'indice de Herfindahl — Plus le score est élevé, plus les ventes sont concentrées chez un petit nombre de clients.</div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            
            <el-divider></el-divider>
            
            <h4>Sommaire de la performance</h4>
            <el-table
                :data="productSummaryPerformance"
                :span-method="objectSpanMethod"
                border
                style="width: 100%;font-size:12px;">
                <el-table-column
                prop="total"
                width="100"
                align="center"
                label="Qte. init.">
                </el-table-column>
                <el-table-column
                prop="totalAdjusted"
                width="100"
                align="center"
                label="Qte. ajustée">
                </el-table-column>
                <el-table-column
                prop="qtyToDate"
                width="100"
                align="center"
                label="Qte. restante">
                </el-table-column>
                <el-table-column
                prop="title"
                width="100"
                label="Type">
                </el-table-column>
                <el-table-column
                align="center"
                label="120 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay120 != null">
                        <span style="margin-left: 10px">{{ scope.row.percent120 }}%({{ scope.row.delay120 }})</span>
                        <span v-if="scope.row.percent120 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent120 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent120  < 80 && scope.row.percent120 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="150 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay150 != null && scope.row.percent120 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent150 }}%({{ scope.row.delay150 }})</span>
                        <span v-if="scope.row.percent150 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent150 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent150  < 80 && scope.row.percent150 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                      </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="180 jours">
                    <template slot-scope="scope">
                        <div v-if="scope.row.delay180 != null && scope.row.percent150 < 100">
                          <span style="margin-left: 10px">{{ scope.row.percent180 }}%({{ scope.row.delay180 }})</span>
                          <span v-if="scope.row.percent180 >= 80"class="mdi mdi-check-circle success-text"></span>
                          <span v-if="scope.row.percent180 < 50" class="mdi mdi-alert-circle danger-text"></span>
                          <span v-if="scope.row.percent180  < 80 && scope.row.percent180 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                        </div>
                        <span v-else>--</span>
                      </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="210 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay210 != null && scope.row.percent180 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent210 }}%({{ scope.row.delay210 }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percent210 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="Hors délais">
                    <template slot-scope="scope">
                      <div v-if="scope.row.overDelay != null && scope.row.percent210 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percentOver }}%({{ scope.row.overDelay }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percentOver >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-divider></el-divider>
              <h4>Historique des ventes</h4>
              <salesGraphics
                v-if="itemSelected"
                :filters="salesHistoryFilters"
                :months="periodMonths"
                :title="'Historique des ventes (' + periodMonths + ' mois)'"
                :showQuantity="true">
              </salesGraphics>
              <el-divider></el-divider>
              <h4>Distribution du produit</h4>
              <p class="secondary-text" style="margin: 0 0 10px 0;">Nombre de clients: {{ distributionTotalClients }}</p>
              <el-table
                :data="paginatedProductDistribution"
                border
                style="width: 100%;font-size:12px;"
                empty-text="Aucune vente pour cette période">
                <el-table-column
                  prop="customer_id"
                  width="120"
                  label="No client">
                </el-table-column>
                <el-table-column
                  prop="customer_name"
                  min-width="260"
                  label="Client">
                </el-table-column>
                <el-table-column
                  prop="total_qty"
                  width="130"
                  align="right"
                  label="Quantité">
                  <template slot-scope="scope">
                    {{ formatNumber(scope.row.total_qty) }}
                  </template>
                </el-table-column>
                <el-table-column
                  width="120"
                  align="right"
                  label="Nb caisses">
                  <template slot-scope="scope">
                    {{ formatNumber(scope.row.total_cases) }}
                  </template>
                </el-table-column>
                <el-table-column
                  width="120"
                  align="right"
                  label="Part %">
                  <template slot-scope="scope">
                    {{ formatNumber(scope.row.share_pct) }}%
                  </template>
                </el-table-column>
              </el-table>
              <div style="text-align:right;margin-top:10px;" v-if="distributionTotalClients > distributionPageSize">
                <el-pagination
                  background
                  layout="prev, pager, next"
                  :page-size="distributionPageSize"
                  :total="distributionTotalClients"
                  :current-page.sync="distributionCurrentPage">
                </el-pagination>
              </div>
              <el-divider></el-divider>
            <h4>Performance par lot</h4>
            <el-table
                :data="itemsPerformance"
                border
                style="width: 100%;font-size:12px;">
                <el-table-column
                fixed
                width="180"
                prop="reference"
                label="Lot">
                </el-table-column>
                <el-table-column
                prop="availabilityDate"
                label="Date de mise en dispo">
                <template slot-scope="scope">
                        <span style="margin-left: 10px">{{ formatDate(scope.row.availabilityDate) }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="vintage"
                align="center"
                label="Millésime">
                </el-table-column>
                <el-table-column
                prop="total"
                align="center"
                label="Qte. init.">
                </el-table-column>
                <el-table-column
                prop="totalAdjusted"
                align="center"
                label="Qte. ajustée">
                </el-table-column>
                <el-table-column
                align="center"
                label="120 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay120 != null">
                        <span style="margin-left: 10px">{{ scope.row.percent120 }}%({{ scope.row.delay120 }})</span>
                        <span v-if="scope.row.percent120 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent120 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent120  < 80 && scope.row.percent120 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="150 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay150 != null && scope.row.percent120 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent150 }}%({{ scope.row.delay150 }})</span>
                        <span v-if="scope.row.percent150 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent150 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent150  < 80 && scope.row.percent150 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="180 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay180 != null && scope.row.percent150 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent180 }}%({{ scope.row.delay180 }})</span>
                        <span v-if="scope.row.percent180 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent180 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent180  < 80 && scope.row.percent180 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="210 jours">
                    <template slot-scope="scope">
                      <div v-if="scope.row.delay210 != null && scope.row.percent180 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percent210 }}%({{ scope.row.delay210 }})</span>
                        <span v-if="scope.row.percent210 >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percent210 < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percent210  < 80 && scope.row.percent210 >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                align="center"
                label="Hors délais">
                    <template slot-scope="scope">
                      <div v-if="scope.row.overDelay != null && scope.row.percent210 < 100">
                        <span style="margin-left: 10px">{{ scope.row.percentOver }}%({{ scope.row.overDelay }})</span>
                        <span v-if="scope.row.percentOver >= 80"class="mdi mdi-check-circle success-text"></span>
                        <span v-if="scope.row.percentOver < 50" class="mdi mdi-alert-circle danger-text"></span>
                        <span v-if="scope.row.percentOver  < 80 && scope.row.percentOver >= 50  "class="mdi mdi-progress-alert warning-text"></span>
                      </div>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="qtyToDate"
                align="center"
                label="Qte. restante">
                </el-table-column>
            </el-table>
              </div>
        </div>
    </div>
</div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import InventoryAPI from '@/services/API/inventory'
import salesAPI from '@/services/API/sales.js'
import ItemTemplate from '@/components/product/item-template-v2'
import salesGraphics from '@/components/sales-graphic'
import dayjs from 'dayjs';
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
export default {
  name : "WineSalesProductPerformance-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      pageWidth : null,
      pageHeight : null,
      itemSelected: null,
      model : {
        item: null,
      },
      itemsPerformance: [],
      productSummaryPerformance: [],
      productDistribution: [],
      distributionCurrentPage: 1,
      distributionPageSize: 10,
      periodMonths: 12,
    };
  },
  components : {
    ItemTemplate,
    salesGraphics,
  },
  computed : {
    reportCode(){
      return this.$route.params.code;
    },
    myInventory(){
        return _.find(this.inventories, inv => inv.code === 'IP');
    },
    salesHistoryFilters(){
        const startDate = dayjs().subtract(this.periodMonths, 'month').startOf('month').toDate();
        const endDate = dayjs().endOf('month').toDate();
        return {
            inventoryId: _.get(this.myInventory, 'id'),
            productId: this.itemSelected ? [this.itemSelected.id] : undefined,
            startDate,
            endDate,
        };
    },
    distributionTotalClients() {
      return this.productDistribution.length;
    },
    paginatedProductDistribution() {
      const from = (this.distributionCurrentPage - 1) * this.distributionPageSize;
      const to = from + this.distributionPageSize;
      return this.productDistribution.slice(from, to);
    },
    concentrationRiskScore() {
      if (!this.productDistribution.length) return 0;
      const hhi = _.sumBy(this.productDistribution, (r) => {
        const s = r.share_pct / 100;
        return s * s;
      });
      return Math.round(hhi * 100);
    },
    concentrationRiskClass() {
      if (this.concentrationRiskScore >= 60) return 'risk-high';
      if (this.concentrationRiskScore >= 30) return 'risk-medium';
      return 'risk-low';
    },
    concentrationRiskLabel() {
      if (this.concentrationRiskScore >= 60) return 'Concentration élevée';
      if (this.concentrationRiskScore >= 30) return 'Concentration modérée';
      return 'Concentration faible';
    },
    perf120Score() {
      const val = parseInt(_.get(_.find(this.productSummaryPerformance, r => r.title === 'CUMUL'), 'percent120', 0));
      return isNaN(val) ? 0 : Math.min(val, 100);
    },
    perf120Class() {
      if (this.perf120Score >= 80) return 'risk-low';
      if (this.perf120Score >= 50) return 'risk-medium';
      return 'risk-high';
    },
    perf120Label() {
      if (this.perf120Score >= 80) return 'Bonne performance';
      if (this.perf120Score >= 50) return 'Performance modérée';
      return 'Performance faible';
    },
    ...mapState('inventory',['inventories']),
  },
  methods : {
    downloadExcel() {
      if (!this.itemSelected) return;

      const wb = XLSX.utils.book_new();

      const summaryRows = _.map(this.productSummaryPerformance, (row) => ({
        'Type': row.title,
        'Qte. init.': this.formatNumber(row.total),
        'Qte. ajustee': this.formatNumber(row.totalAdjusted),
        'Qte. restante': this.formatNumber(row.qtyToDate),
        '120 jours': row.delay120 != null ? `${row.percent120}% (${row.delay120})` : '--',
        '150 jours': row.delay150 != null ? `${row.percent150}% (${row.delay150})` : '--',
        '180 jours': row.delay180 != null ? `${row.percent180}% (${row.delay180})` : '--',
        '210 jours': row.delay210 != null ? `${row.percent210}% (${row.delay210})` : '--',
        'Hors delais': row.overDelay != null ? `${row.percentOver}% (${row.overDelay})` : '--',
      }));

      const distributionRows = _.map(this.productDistribution, (row) => ({
        'No client': row.customer_id,
        'Client': row.customer_name,
        'Quantite': this.formatNumber(row.total_qty),
        'Nb caisses': this.formatNumber(row.total_cases),
        'Part %': this.formatNumber(row.share_pct),
      }));

      const lotRows = _.map(this.itemsPerformance, (row) => ({
        'Lot': row.reference,
        'Date de mise en dispo': this.formatDate(row.availabilityDate),
        'Millesime': row.vintage,
        'Qte. init.': this.formatNumber(row.total),
        'Qte. ajustee': this.formatNumber(row.totalAdjusted),
        'Qte. restante': this.formatNumber(row.qtyToDate),
        '120 jours': row.delay120 != null ? `${row.percent120}% (${row.delay120})` : '--',
        '150 jours': row.delay150 != null ? `${row.percent150}% (${row.delay150})` : '--',
        '180 jours': row.delay180 != null ? `${row.percent180}% (${row.delay180})` : '--',
        '210 jours': row.delay210 != null ? `${row.percent210}% (${row.delay210})` : '--',
        'Hors delais': row.overDelay != null ? `${row.percentOver}% (${row.overDelay})` : '--',
      }));

      const infoRows = [{
        'Produit': _.get(this.itemSelected, 'name', ''),
        'SKU': _.get(this.itemSelected, 'sku', ''),
        'Periode (mois)': this.periodMonths,
        'Date debut': dayjs().subtract(this.periodMonths, 'month').startOf('month').format('YYYY-MM-DD'),
        'Date fin': dayjs().endOf('month').format('YYYY-MM-DD'),
        'Indice concentration (0-100)': this.concentrationRiskScore,
        'Niveau de concentration': this.concentrationRiskLabel,
      }];

      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(infoRows), 'Info');
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryRows), 'Sommaire');
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(distributionRows), 'Distribution');
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(lotRows), 'Par lot');

      const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
      const fileName = `performance-produit-${_.get(this.itemSelected, 'sku', 'produit')}-${dayjs().format('YYYY-MM-DD')}.xlsx`;
      saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), fileName);
    },
    formatNumber(value) {
      return Math.round(Number(value || 0) * 100) / 100;
    },
    fetchProductDistribution() {
      if (!this.itemSelected || !_.get(this.myInventory, 'id')) {
        this.productDistribution = [];
        return Promise.resolve();
      }

      const startDate = dayjs().subtract(this.periodMonths, 'month').startOf('month').format('YYYY-MM-DD Z');
      const endDate = dayjs().endOf('month').format('YYYY-MM-DD Z');
      const filters = {
        inventoryId: _.get(this.myInventory, 'id'),
        productId: this.itemSelected.id,
        startDate,
        endDate,
      };

      return salesAPI.getSummaryCustomerSalesByProduct(filters)
        .then((rows) => {
          const totalQty = _.sumBy(rows, r => Number(r.total_qty || 0));
          this.productDistribution = _.orderBy(_.map(rows, (r) => {
            const qty = Number(r.total_qty || 0);
            const uvc = Number(r.uvc || _.get(this.itemSelected, 'uvc') || 0);
            const totalCases = uvc > 0 ? qty / uvc : 0;
            return {
              customer_id: r.customer_id,
              customer_name: r.customer_name,
              total_qty: qty,
              total_cases: totalCases,
              share_pct: totalQty > 0 ? (qty / totalQty) * 100 : 0,
            };
          }), ['total_qty'], ['desc']);
          this.distributionCurrentPage = 1;
        })
        .catch(() => {
          this.productDistribution = [];
          this.distributionCurrentPage = 1;
        });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex <= 2) {
          if (rowIndex  === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
    formatDate(date, format = 'YYYY-MM-DD') {
        return dayjs(date).format(format);
    },
    querySearch(queryString, cb){
        return InventoryAPI.fetchProductsV2({ inventoryId: _.get(this.myInventory, 'id'), searchTerms: queryString, paging: 'no', limit:25}, _.get(this.myInventory, 'id'))
          .then(products => {
            cb(products);
          })
    },
    fetchItemsPerformanceIfSelected() {
        if (this.itemSelected) {
        this.fetchItemsPerformance();
        this.fetchProductDistribution();
        }
    },
    applyRouteSelection() {
      const months = parseInt(_.get(this.$route, 'query.months'), 10);
      if (!Number.isNaN(months) && months > 0) {
        this.periodMonths = months;
      }

      const puid = _.get(this.$route, 'query.puid');
      if (puid == null || puid === '') {
        return Promise.resolve();
      }

      return InventoryAPI.getInventoryProductV2(puid)
        .then((product) => {
          if (product == null) {
            return;
          }
          this.itemSelected = product;
          this.model.item = _.get(product, 'name', '');
          this.fetchItemsPerformance();
          this.fetchProductDistribution();
        })
        .catch(() => {
          this.$message.error('Impossible de charger le produit selectionne.');
        });
    },
    fetchItemsPerformance() {
        const startDate = dayjs().subtract(this.periodMonths, 'month').startOf('month').format('YYYY-MM-DD');
        const itemPuids = _.chain(_.get(this.itemSelected, 'items', []))
          .map('puid')
          .filter(Boolean)
          .uniq()
          .value();

        if (!itemPuids.length) {
          this.itemsPerformance = [];
          this.productSummaryPerformance = [];
          return;
        }

        Promise.all(itemPuids.map((itemPuid) => InventoryAPI.fetchProductPuidItemsPerformance(itemPuid, _.get(this.myInventory, 'id'), { startDate })))
            .then((performancesByPuid) => {
                const performance = _.chain(performancesByPuid)
                  .flatten()
                  .uniqBy('id')
                  .value();
                const filteredPerformance = _.filter(performance, p => !p.availabilityDate || dayjs(p.availabilityDate).isAfter(dayjs(startDate).subtract(1, 'day')));
                this.itemsPerformance = [];
                this.productSummaryPerformance = [];
                const summaryPerformanceCumul = { // cumulatif
                    total: 0,
                    delay120: 0,
                    delay150: 0,
                    delay180: 0,
                    delay210: 0,
                    overDelay: 0,
                    qtyToDate: 0,
                    totalAdjusted: 0,
                }
                const summaryPerformance = {  // par jours délais non cumulatif
                    total: 0,
                    delay120: 0,
                    delay150: 0,
                    delay180: 0,
                    delay210: 0,
                    overDelay: 0,
                    qtyToDate: 0,
                    totalAdjusted: 0,
                }
                _.forEach(filteredPerformance, p => {
                    
                    const item = _.find(this.itemSelected.items, i => i.id === p.id);
                    summaryPerformanceCumul.total += item.qty;

                    var qty = p.delay120;
                    summaryPerformanceCumul.delay120 += qty;
                    if (p.delay150 != null) {
                      qty = p.delay150;
                    }

                    summaryPerformanceCumul.delay150 += qty;
                    if (p.delay180 != null) {
                      qty = p.delay180;
                    }

                    summaryPerformanceCumul.delay180 += qty;
                    if (p.delay210 != null) {
                      qty = p.delay210;
                    }
                    summaryPerformanceCumul.delay210 += qty;
                    if (p.overDelay != null) {
                      qty = p.overDelay;
                    }
                    
                    summaryPerformanceCumul.overDelay += qty;
                    summaryPerformanceCumul.qtyToDate += _.get(item, 'quantity.onHand');
                    const totalAdjusted =  _.get(item, 'quantity.onHand') + _.get(item, 'quantity.packaged');
                    summaryPerformanceCumul.totalAdjusted += totalAdjusted;
                    
                    this.itemsPerformance.push({
                        id: p.id,
                        reference: p.reference,
                        availabilityDate: p.availabilityDate,
                        vintage: _.get(p, 'extraInfo.vintage'),
                        total: item.qty,
                        totalAdjusted,
                        delay120: p.delay120,
                        percent120: ((p.delay120 / totalAdjusted) * 100).toFixed(0),
                        delay150: p.delay150,
                        percent150: ((p.delay150 / totalAdjusted)* 100).toFixed(0),
                        delay180: p.delay180,
                        percent180: ((p.delay180 / totalAdjusted) * 100).toFixed(0),
                        delay210: p.delay210,
                        percent210: ((p.delay210 / totalAdjusted) * 100).toFixed(0),
                        overDelay: p.overDelay,
                        percentOver: ((p.overDelay / totalAdjusted) * 100).toFixed(0),
                        qtyToDate: _.get(item, 'quantity.onHand'),
                    })
                })
                
                summaryPerformanceCumul.percent120 = ((summaryPerformanceCumul.delay120 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent150 = ((summaryPerformanceCumul.delay150 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent180 = ((summaryPerformanceCumul.delay180 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percent210 = ((summaryPerformanceCumul.delay210 / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.percentOver = ((summaryPerformanceCumul.overDelay / summaryPerformanceCumul.totalAdjusted) * 100).toFixed(0);
                summaryPerformanceCumul.title="CUMUL";

                var soldOut = false;
                summaryPerformance.delay120 = summaryPerformanceCumul.delay120;
                if (summaryPerformanceCumul.percent120 === "100") soldOut = true;
                summaryPerformance.delay150 = !soldOut ? summaryPerformanceCumul.delay150 - summaryPerformanceCumul.delay120 : null;
                if (summaryPerformanceCumul.percent150 === "100" || soldOut === true) soldOut = true;
                summaryPerformance.delay180 = !soldOut ? summaryPerformanceCumul.delay180 - summaryPerformanceCumul.delay150 : null;
                if (summaryPerformanceCumul.percent180 === "100"  || soldOut === true) soldOut = true;
                summaryPerformance.delay210 = !soldOut ? summaryPerformanceCumul.delay210 - summaryPerformanceCumul.delay180 : null;
                if (summaryPerformanceCumul.percent210 === "100"  || soldOut === true) soldOut = true;
                summaryPerformance.overDelay = !soldOut ? summaryPerformanceCumul.overDelay - summaryPerformanceCumul.delay210 : null;
                summaryPerformance.totalAdjusted = summaryPerformanceCumul.totalAdjusted;
                summaryPerformance.total = summaryPerformanceCumul.total;

                summaryPerformance.percent120 = ((summaryPerformance.delay120 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent150 = ((summaryPerformance.delay150 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent180 = ((summaryPerformance.delay180 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percent210 = ((summaryPerformance.delay210 / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.percentOver = ((summaryPerformance.overDelay / summaryPerformance.totalAdjusted) * 100).toFixed(0);
                summaryPerformance.title="BY_DELAY";

                this.productSummaryPerformance.push(summaryPerformance);
                this.productSummaryPerformance.push(summaryPerformanceCumul);
            })
            .catch(() => {
              this.itemsPerformance = [];
              this.productSummaryPerformance = [];
              this.$message.error('Une erreur systeme est survenue. Veuillez reessayer plus tard');
            });
    },
    handleSelect (selectedItem) {
        this.itemSelected = selectedItem;
        //On va fetcher les informations sur la performance des items
        this.fetchItemsPerformance();
      this.fetchProductDistribution();
        
    },
    setPageWidth() {
        this.pageWidth = document.getElementById('page-panel').offsetWidth;
        this.pageHeight = document.getElementById('page-panel').offsetHeight;
    },
    ...mapActions('inventory',['fetchInventories'])
  },
  mounted(){
    this.setPageWidth();
  },
  beforeDestroy(){
    this.data = [];
  },
  created(){
    this.fetchInventories()
      .then(() => this.applyRouteSelection());
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.empty-selection-message {
  padding: 14px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background-color: #f5f7fa;
  color: #606266;
  font-size: 13px;
}

.concentration-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  padding: 12px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #fafafa;
  text-align: center;
}

.concentration-title {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  line-height: 1.4;
}

.concentration-score {
  font-size: 48px;
  font-weight: bold;
  line-height: 1;
}

.concentration-unit {
  font-size: 16px;
  font-weight: normal;
}

.concentration-label {
  font-size: 13px;
  font-weight: 600;
  margin-top: 6px;
}

.concentration-hint {
  font-size: 10px;
  color: #aaa;
  margin-top: 8px;
  line-height: 1.4;
}

.risk-low  { color: #67c23a; }
.risk-medium { color: #e6a23c; }
.risk-high { color: #f56c6c; }


</style>